import axios from "axios";

const API_BASE ="https://api.monappliclub.com";

const baseUrl = `${API_BASE}/api/parrainage`;

export const createReferral = async (payload) => {
  const { data } = await axios.post(`${baseUrl}/addParrainage`, payload);
  return data;
};